import { graphql } from 'react-apollo';
import MEDIA_DELETE from '../graphql/MediaDelete.graphql';

export const withMediaDeleting = graphql(MEDIA_DELETE, {
  props: ({ mutate }) => ({
    mediaDelete: async (id: number) => mutate({ variables: { id } })
  })
});

export default withMediaDeleting;